<template>
  <VCard elevation="1" class="pa-0 pa-md-4 px-md-12 mb-5 grey--text text--darken-4">
    <div>{{ $t('title') }}</div>
  </VCard>
</template>

<script>
export default {
  name: 'CandidateWaiting',
  metaInfo() {
    return {
      title: this.$t('title'),
    };
  },
};
</script>

<i18n locale="en" lang="yaml">
  title: We look forward to your interview
</i18n>

<i18n locale="ru" lang="yaml">
  title: Ждем вас на собеседовании
</i18n>
